import { types } from "./actions";

const token = window.localStorage.getItem("token")

const initialState = {
    token: token || null
}

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SIGN_OUT:
            return {
                ...initialState,
                token: null
            }
        case types.SIGN_IN_BEGIN:
            return {
                ...state,
                signingIn: true
            };
        case types.SIGN_IN_COMPLETE:
            return {
                ...state,
                signingIn: false,
                token: action.payload
            };
        case types.FETCH_USER_BEGIN:
            return {
                ...state,
                fetchingUser: true
            }
        case types.FETCH_USER_COMPLETE:
            return {
                ...state,
                fetchingUser: false,
                user: action.payload
            }
        case types.FETCH_USERS_BEGIN:
            return {
                ...state,
                fetchingUsers: true
            }
        case types.FETCH_USERS_COMPLETE:
            return {
                ...state,
                fetchingUsers: false,
                users: action.payload
            }
        case types.FETCH_TENANT_BEGIN:
            return {
                ...state,
                fetchingTenant: true
            }
        case types.FETCH_TENANT_COMPLETE:
            return {
                ...state,
                fetchingTenant: false,
                tenant: action.payload
            }
        case types.FETCH_TENANTS_BY_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                fetchingTenants: true
            }
        case types.FETCH_TENANTS_BY_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                fetchingTenants: false,
                tenants: action.payload
            }
        case types.FETCH_TENANT_INVOICE_DETAILS_BEGIN:
            return {
                ...state,
                fetchingTenantInvoiceDetails: true
            }
        case types.FETCH_TENANT_INVOICE_DETAILS_COMPLETE:
            return {
                ...state,
                fetchingTenantInvoiceDetails: false,
                tenantInvoiceDetails: action.payload
            }
        case types.FETCH_TENANT_ATTEST_STATS_BEGIN:
            return {
                ...state,
                fetchingTenantAttestStats: true
            }
        case types.FETCH_TENANT_ATTEST_STATS_COMPLETE:
            return {
                ...state,
                fetchingTenantAttestStats: false,
                tenantAttestStats: action.payload
            }
        case types.FETCH_TENANT_PROJECT_FORM_STATS_BEGIN:
            return {
                ...state,
                fetchingTenantProjectFormStats: true
            }
        case types.FETCH_TENANT_PROJECT_FORM_STATS_COMPLETE:
            return {
                ...state,
                fetchingTenantProjectFormStats: false,
                tenantProjectFormStats: action.payload
            }
        case types.FETCH_TENANT_BOOKING_STATS_BEGIN:
            return {
                ...state,
                fetchingTenantBookingStats: true
            }
        case types.FETCH_TENANT_BOOKING_STATS_COMPLETE:
            return {
                ...state,
                fetchingTenantBookingStats: false,
                tenantBookingStats: action.payload
            }
        case types.FETCH_TENANT_GENERAL_INFO_BEGIN:
            return {
                ...state,
                fetchingTenantGeneralInfo: true
            }
        case types.FETCH_TENANT_GENERAL_INFO_COMPLETE:
            return {
                ...state,
                fetchingTenantGeneralInfo: false,
                tenantGeneralInfo: action.payload
            }
        case types.FETCH_TENANTS_BEGIN:
            return {
                ...state,
                fetchingTenants: true
            }
        case types.FETCH_TENANTS_COMPLETE:
            return {
                ...state,
                fetchingTenants: false,
                tenants: action.payload
            }
        case types.FETCH_USER_TENANT_CONNECTIONS_BEGIN:
            return {
                ...state,
                fetchingUserTenantConnections: true
            }
        case types.FETCH_USER_TENANT_CONNECTIONS_COMPLETE:
            return {
                ...state,
                fetchingUserTenantConnections: false,
                userTenantConnections: action.payload
            }
        case types.LOAD_TENANTS_COUNT_BEGIN:
            return {
                ...state,
                loadingTenantsCount: true
            }
        case types.LOAD_TENANTS_COUNT_SUCCESS:
            return {
                ...state,
                loadingTenantsCount: false,
                tenantsCount: action.payload
            }
        case types.FETCH_CREDIT_CARD_RECEIPTS_BEGIN:
            return {
                ...state,
                fetchingCreditCardReceipts: true,
            }
        case types.FETCH_CREDIT_CARD_RECEIPTS_COMPLETE:
            return {
                ...state,
                fetchingCreditCardReceipts: false,
                creditCardReceipts: action.payload
            }
        case types.FETCH_LANGUAGES_BEGIN:
            return {
                ...state,
                fetchingLanguages: true
            }
        case types.FETCH_LANGUAGES_COMPLETE:
            return {
                ...state,
                fetchingLanguages: false,
                languages: action.payload
            }
        case types.FETCH_TENANT_LANGUAGES_BEGIN:
            return {
                ...state,
                fetchingTenantLanguages: true
            }
        case types.FETCH_TENANT_LANGUAGES_COMPLETE:
            return {
                ...state,
                fetchingTenantLanguages: false,
                tenantLanguages: action.payload
            }
        case types.FETCH_PAYMENT_METHODS_BEGIN:
            return {
                ...state,
                fetchingPaymentMethods: true
            }
        case types.FETCH_PAYMENT_METHODS_COMPLETE:
            return {
                ...state,
                fetchingPaymentMethods: false
            }
        case types.FETCH_FEATURE_FLAGS_BEGIN:
            return {
                ...state,
                fetchingFeatureFlags: true
            }
        case types.FETCH_FEATURE_FLAGS_COMPLETE:
            return {
                ...state,
                fetchingFeatureFlags: false,
                featureFlags: action.payload
            }
        case types.FETCH_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                fetchingFeatureFlag: true
            }
        case types.FETCH_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                fetchingFeatureFlag: false,
                featureFlag: action.payload
            }
        case types.FETCH_TENANT_FEATURE_FLAGS_BEGIN:
            return {
                ...state,
                fetchingTenantFeatureFlags: true
            }
        case types.FETCH_TENANT_FEATURE_FLAGS_COMPLETE:
            return {
                ...state,
                fetchingTenantFeatureFlags: false,
                tenantFeatureFlags: action.payload
            }
        case types.FETCH_TENANT_SETTINGS_BEGIN:
            return {
                ...state,
                fetchingTenantSettings: true
            }
        case types.FETCH_TENANT_SETTINGS_COMPLETE:
            return {
                ...state,
                fetchingTenantSettings: false,
                tenantSettings: action.payload
            }
        case types.FETCH_USER_CERTIFICATES_BEGIN:
            return {
                ...state,
                fetchingUserCertificates: true
            }
        case types.FETCH_USER_CERTIFICATES_COMPLETE:
            return {
                ...state,
                fetchingUserCertificates: false,
                userCertificates: action.payload
            }
        case types.FETCH_TENANT_EMPLOYEES_BEGIN:
            return {
                ...state,
                fetchingTenantEmployees: true
            }
        case types.FETCH_TENANT_EMPLOYEES_COMPLETE:
            return {
                ...state,
                fetchingTenantEmployees: false,
                tenantEmployees: action.payload
            }
        case types.CREATE_USER_BEGIN:
            return {
                ...state,
                creatingUser: true
            }
        case types.CREATE_USER_SUCCESS:
            return {
                ...state,
                creatingUser: false
            }
        case types.CREATE_TENANT_BEGIN:
            return {
                ...state,
                creatingTenant: true
            }
        case types.CREATE_TENANT_SUCCESS:
            return {
                ...state,
                creatingTenant: false
            }
        case types.CREATE_USER_TENANT_CONNECTION_BEGIN:
            return {
                ...state,
                creatingUserTenantConnection: true
            }
        case types.CREATE_USER_TENANT_CONNECTION_SUCCESS:
            return {
                ...state,
                creatingUserTenantConnection: false
            }           
        case types.CREATE_LANGUAGE_BEGIN:
            return {
                ...state,
                creatingLanguage: true
            }            
        case types.CREATE_LANGUAGE_COMPLETE:
            return {
                ...state,
                creatingLanguage: false
            }            
        case types.CREATE_TENANT_LANGUAGE_BEGIN:
            return {
                ...state,
                creatingTenantLanguage: true
            }            
        case types.CREATE_TENANT_LANGUAGE_COMPLETE:
            return {
                ...state,
                creatingTenantLanguage: false
            }            
        case types.CREATE_PAYMENT_METHOD_BEGIN:
            return {
                ...state,
                creatingPaymentMethod: true
            }            
        case types.CREATE_PAYMENT_METHOD_COMPLETE:
            return {
                ...state,
                creatingPaymentMethod: false
            }            
        case types.CREATE_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                creatingFeatureFlag: true
            }            
        case types.CREATE_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                creatingFeatureFlag: false
            }            
        case types.CREATE_TENANT_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                creatingTenantFeatureFlag: true
            }            
        case types.CREATE_TENANT_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                creatingTenantFeatureFlag: false
            }            
        case types.CREATE_USER_CERTIFICATE_BEGIN:
            return {
                ...state,
                creatingUserCertificate: true
            }            
        case types.CREATE_USER_CERTIFICATE_COMPLETE:
            return {
                ...state,
                creatingUserCertificate: false
            }            
        case types.UPDATE_USER_BEGIN:
            return {
                ...state,
                updatingUser: true
            }
        case types.UPDATE_USER_SUCCESS:
            return {
                ...state,
                updatingUser: false
            }
        case types.UPDATE_TENANT_BEGIN:
            return {
                ...state,
                updatingTenant: true
            }
        case types.UPDATE_TENANT_SUCCESS:
            return {
                ...state,
                updatingTenant: false
            }
        case types.UPDATE_TENANT_MIGRATION_STATUS_BEGIN:
            return {
                ...state,
                updatingTenant: true
            }
        case types.UPDATE_TENANT_MIGRATION_STATUS_SUCCESS:
            return {
                ...state,
                updatingTenant: false,
                tenant: action.payload,
            }
        case types.UPDATE_USER_TENANT_CONNECTION_BEGIN:
            return {
                ...state,
                updatingUserTenantConnection: true
            }
        case types.UPDATE_USER_TENANT_CONNECTION_SUCCESS:
            return {
                ...state,
                updatingUserTenantConnection: false
            }
        case types.UPDATE_CREDIT_CARD_RECEIPT_BEGIN:
            return {
                ...state,
                updatingCreditCardReceipt: true
            }            
        case types.UPDATE_CREDIT_CARD_RECEIPT_COMPLETE:
            return {
                ...state,
                updatingCreditCardReceipt: false
            }            
        case types.UPDATE_LANGUAGE_BEGIN:
            return {
                ...state,
                updatingLanguage: true
            }            
        case types.UPDATE_LANGUAGE_COMPLETE:
            return {
                ...state,
                updatingLanguage: false
            }            
        case types.UPDATE_TENANT_LANGUAGE_BEGIN:
            return {
                ...state,
                updatingTenantLanguage: true
            }            
        case types.UPDATE_TENANT_LANGUAGE_COMPLETE:
            return {
                ...state,
                updatingTenantLanguage: false
            }            
        case types.UPDATE_PAYMENT_METHOD_BEGIN:
            return {
                ...state,
                updatingPaymentMethod: true
            }            
        case types.UPDATE_PAYMENT_METHOD_COMPLETE:
            return {
                ...state,
                updatingPaymentMethod: false
            }            
        case types.UPDATE_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                updatingFeatureFlag: true
            }            
        case types.UPDATE_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                updatingFeatureFlag: false
            }            
        case types.UPDATE_TENANT_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                updatingTenantFeatureFlag: true
            }            
        case types.UPDATE_TENANT_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                updatingTenantFeatureFlag: false
            }            
        case types.UPDATE_USER_CERTIFICATE_BEGIN:
            return {
                ...state,
                updatingUserCertificate: true
            }            
        case types.UPDATE_USER_CERTIFICATE_COMPLETE:
            return {
                ...state,
                updatingUserCertificate: false
            }
        case types.UPDATE_TENANT_SETTING_COMPLETE:
            return {
                ...state,
                updatingTenantSetting: false
            }
        case types.DELETE_USER_BEGIN:
            return {
                ...state,
                deletingUser: true
            }
        case types.DELETE_USER_SUCCESS:
            return {
                ...state,
                deletingUser: false
            }
        case types.DELETE_TENANT_BEGIN:
            return {
                ...state,
                deletingTenant: true
            }
        case types.DELETE_TENANT_SUCCESS:
            return {
                ...state,
                deletingTenant: false
            }
        case types.DELETE_USER_TENANT_CONNECTION_BEGIN:
            return {
                ...state,
                deletingUserTenantConnection: true
            }
        case types.DELETE_USER_TENANT_CONNECTION_SUCCESS:
            return {
                ...state,
                deletingUserTenantConnection: false
            }
        case types.DELETE_LANGUAGE_BEGIN:
            return {
                ...state,
                deletingLanguage: true
            }            
        case types.DELETE_LANGUAGE_COMPLETE:
            return {
                ...state,
                deletingLanguage: false
            }            
        case types.DELETE_TENANT_LANGUAGE_BEGIN:
            return {
                ...state,
                deletingTenantLanguage: true
            }            
        case types.DELETE_TENANT_LANGUAGE_COMPLETE:
            return {
                ...state,
                deletingTenantLanguage: false
            }            
        case types.DELETE_PAYMENT_METHOD_BEGIN:
            return {
                ...state,
                deletingPaymentMethod: true
            }            
        case types.DELETE_PAYMENT_METHOD_COMPLETE:
            return {
                ...state,
                deletingPaymentMethod: false
            }            
        case types.DELETE_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                deletingFeatureFlag: true
            }            
        case types.DELETE_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                deletingFeatureFlag: false
            }            
        case types.DELETE_TENANT_FEATURE_FLAG_BEGIN:
            return {
                ...state,
                deletingTenantFeatureFlag: true
            }            
        case types.DELETE_TENANT_FEATURE_FLAG_COMPLETE:
            return {
                ...state,
                deletingTenantFeatureFlag: false
            }            
        case types.DELETE_USER_CERTIFICATE_BEGIN:
            return {
                ...state,
                deletingUserCertificate: true
            }            
        case types.DELETE_USER_CERTIFICATE_COMPLETE:
            return {
                ...state,
                deletingUserCertificate: false
            } 
        case types.LOAD_ACTIVE_USERS_BETWEEN_DATES_BEGIN:
            return {
                ...state,
                loadingActiveUsersBetweenDates: true
            }            
        case types.LOAD_ACTIVE_USERS_BETWEEN_DATES_SUCCESS:
            return {
                ...state,
                activeUsers: action.payload,
                loadingActiveUsersBetweenDates: false
            } 
        case types.LOAD_ACTIVE_USERS_BY_DAY_BEGIN:
            return {
                ...state,
                loadingActiveUsersByDay: true
            }            
        case types.LOAD_ACTIVE_USERS_BY_DAY_SUCCESS:
            return {
                ...state,
                activeUsers: action.payload,
                loadingActiveUsersByDay: false
            } 
        case types.LOAD_ACTIVE_USERS_BY_DAY2_BEGIN:
            return {
                ...state,
                loadingActiveUsersByDay2: true
            }            
        case types.LOAD_ACTIVE_USERS_BY_DAY2_SUCCESS:
            return {
                ...state,
                activeUsers2: action.payload,
                loadingActiveUsersByDay2: false
            } 
        case types.LOAD_ACTIVE_USERS_BETWEEN_DATES2_BEGIN:
            return {
                ...state,
                loadingActiveUsersBetweenDates2: true
            }            
        case types.LOAD_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS:
            return {
                ...state,
                activeUsers2: action.payload,
                loadingActiveUsersBetweenDates2: false
            } 
        case types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_BEGIN:
            return {
                ...state,
                loadingTenantActiveUsersBetweenDates: true
            }            
        case types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES_SUCCESS:
            return {
                ...state,
                tenantActiveUsers: action.payload,
                loadingTenantActiveUsersBetweenDates: false
            } 
        case types.LOAD_TENANT_ACTIVE_USERS_BY_DAY_BEGIN:
            return {
                ...state,
                loadingTenantActiveUsersByDay: true
            }            
        case types.LOAD_TENANT_ACTIVE_USERS_BY_DAY_SUCCESS:
            return {
                ...state,
                tenantActiveUsers: action.payload,
                loadingTenantActiveUsersByDay: false
            } 
        case types.LOAD_TENANT_ACTIVE_USERS_BY_DAY2_BEGIN:
            return {
                ...state,
                loadingTenantActiveUsersByDay2: true
            }            
        case types.LOAD_TENANT_ACTIVE_USERS_BY_DAY2_SUCCESS:
            return {
                ...state,
                tenantActiveUsers2: action.payload,
                loadingTenantActiveUsersByDay2: false
            } 
        case types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_BEGIN:
            return {
                ...state,
                loadingTenantActiveUsersBetweenDates2: true
            }            
        case types.LOAD_TENANT_ACTIVE_USERS_BETWEEN_DATES2_SUCCESS:
            return {
                ...state,
                tenantActiveUsers2: action.payload,
                loadingTenantActiveUsersBetweenDates2: false
            } 
        case types.LOAD_TENANT_DATA_BEGIN:
            return {
                ...state,
                loadingTenantData: true
            }            
        case types.LOAD_TENANT_DATA_SUCCESS:
            return {
                ...state,
                tenantData: action.payload,
                loadingTenantData: false
            } 
        case types.CHECK_GADGET_MIGRATION_STATUS_BEGIN:
            return {
                ...state,
                checkingGadgetMigrationStatus: true
            }            
        case types.CHECK_GADGET_MIGRATION_STATUS_SUCCESS:
            return {
                ...state,
                checkingGadgetMigrationStatus: false,
                gadgetMigrationStatus: action.payload
            }
        case types.CHECK_GADGET_TEST_MIGRATION_STATUS_BEGIN:
            return {
                ...state,
                checkingGadgetTestMigrationStatus: true
            }            
        case types.CHECK_GADGET_TEST_MIGRATION_STATUS_SUCCESS:
            return {
                ...state,
                checkingGadgetTestMigrationStatus: false,
                gadgetTestMigrationStatus: action.payload
            }
    default:
            return {
                ...state,
            };
            // return initialState
    }
}

export default appReducer
